import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useAuth } from '../contexts/AuthContext';
import InnerPage from "../components/layout/InnerPage";
import Card from '../components/ui/Card';
import Input from '../components/ui/Input';
import Button from '../components/ui/Button';
import './Auth.css';
import './ResetPassword.css';

const ForgotPassword = () => {
  const { forgotPassword, loading } = useAuth();
  const [emailSent, setEmailSent] = useState(false);
  
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    clearErrors
  } = useForm();

  const onSubmit = async (data) => {
    clearErrors();
    
    const result = await forgotPassword(data.email);
    
    if (result.success) {
      setEmailSent(true);
    } else {
      setError('root', {
        type: 'manual',
        message: result.error
      });
    }
  };

  if (emailSent) {
    return (
      <InnerPage title="Reset Password">
        <div className="forgot-password-container">
          <div className="auth-container">
            <Card
              className="auth-card"
              title="Check Your Email"
              subtitle="We've sent you a password reset link"
            >
              <div className="auth-alert auth-alert-success">
                <span>📧</span>
                <div>
                  <strong>Password reset email sent!</strong>
                  <p>Please check your email and click the link to reset your password. The link will expire in 1 hour.</p>
                </div>
              </div>

              <div className="auth-actions">
                <p className="auth-text">
                  Didn't receive the email?{' '}
                  <button
                    onClick={() => setEmailSent(false)}
                    className="auth-link"
                    style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                  >
                    Try again
                  </button>
                </p>
                <p className="auth-text">
                  Remember your password?{' '}
                  <Link to="/login" className="auth-link">
                    Sign in here
                  </Link>
                </p>
              </div>
            </Card>
          </div>
        </div>
      </InnerPage>
    );
  }

  return (
    <InnerPage title="Reset Password">
      <div className="forgot-password-container">
        <div className="">
          <Card
            className="card-no-padding"
            title="Reset Password"
            subtitle="Enter your email to receive a password reset link"
          >
            {errors.root && (
              <div className="auth-alert auth-alert-error">
                <span>❌</span>
                <div>
                  <strong>Request failed</strong>
                  <p>{errors.root.message}</p>
                </div>
              </div>
            )}

            <form onSubmit={handleSubmit(onSubmit)} className="one-column-form white-form">
              <Input
                label="Email Address"
                type="email"
                placeholder="Enter your email"
                required
                error={errors.email?.message}
                {...register('email', {
                  required: 'Email is required',
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: 'Please enter a valid email address'
                  }
                })}
              />

              <Button
                type="submit"
                variant="primary"
                size="large"
                fullWidth
                loading={loading}
                disabled={loading}
              >
                Send Reset Link
              </Button>
            </form>

            <div className="auth-divider">
              <span>or</span>
            </div>

            <div className="auth-actions">
              <p className="auth-text">
                Remember your password?{' '}
                <Link to="/login" className="auth-link">
                  Sign in here
                </Link>
              </p>
            </div>
          </Card>
        </div>
      </div>
    </InnerPage>
  );
};

export default ForgotPassword;
